module.exports = __webpack_public_path__ + "media/public/img/x-round-01-2a040f8114114d748f4f633894d6978b.svg";